// extracted by mini-css-extract-plugin
export default {"tabs":"k9-z","tablist":"l9-z","tablistItem":"m9-z"};